<div class="p-3">
  <div class="row border-bottom">
    <h6 class="px-3"><b>{{ isEdit ? 'Update governance activity' : 'Create governance activity' }}</b></h6>
  </div>
  <form [formGroup]="createForm" class="d-flex flex-column row">
    <div class="row m-0 pt-2">
      <div class="col-4">
        <label>Activity type *</label>
        <ng-select [items]="activityTypes" [multiple]="false" bindLabel="displayText"
          bindValue="id" formControlName="activityType">
        </ng-select>
      </div>
      <div class="col-2">
        <label>Order *</label>
        <input type="number" class="w-100 form-control form-control-sm" formControlName="order" />
      </div>
    </div>
    <div class="row m-0 py-2">
      <div class="col">
        <label>Header *</label>
        <textarea class="w-100 form-control form-control-sm" formControlName="header"></textarea>
      </div>
      <div class="col">
        <label>Description *</label>
        <textarea class="w-100 form-control form-control-sm" formControlName="description"></textarea>
      </div>
    </div>
    <div class="row m-0 pt-2">
      <div class="px-3">
        <label for="common">
          <input id="common" type="checkbox" formControlName="isCommon"
            (change)="onCommonChange($event.target.checked)" />
          Common activity (applies to all document types)
        </label>
      </div>
    </div>
    <div class="row m-0 py-2" *ngIf="!createForm.controls.isCommon.value">
      <div class="col-4">
        <label>Country *</label>
        <ng-select [items]="countries" formControlName="country" bindLabel="displayText"
          [placeholder]="'Select country'" (change)="onCountryChange($event)">
        </ng-select>
      </div>
      <div class="col-4">
        <label>Office Location *</label>
        <ng-select [items]="filteredOfficeLocations" formControlName="officeLocation" bindLabel="displayText"
          [placeholder]="'Select office location'" (change)="onOfficeLocationChange($event)">
        </ng-select>
      </div>
      <div class="col-4">
        <label>Legal Entity *</label>
        <ng-select [items]="filteredLegalEntities" formControlName="legalEntity" bindLabel="displayText" [multiple]="true" [closeOnSelect]="false"
          [placeholder]="'Select legal entity'" (change)="onLegalEntityChange($event)">
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
              <div class="ng-value" *ngFor="let item of items | slice : 0 : 1">
                <span class="ng-value-label" title={{item.displayText}}> {{ (item.displayText &&
                  item.displayText.length>20)? (item.displayText | slice:0:20)+'...':(item.displayText) }}</span>
                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
              </div>
              <div class="ng-value" *ngIf="items.length > 1">
                <span class="ng-value-label">+{{ items.length - 1 }}</span>
              </div>
            </ng-template>
        </ng-select>
      </div>
      <div class="col-4 mt-2">
        <label>Document Type *</label>
        <ng-select [items]="filteredDocumentTypes" formControlName="documentType"
          bindLabel="documentTypeName" [placeholder]="'Select document type'"
          (change)="onDocumentTypeChange($event)">
        </ng-select>
        <div *ngIf="missingLEsForDocType.length > 0" class="mt-1">
          <small class="text-danger d-block">
            No document configuration found for:
            <span *ngFor="let le of missingLEsForDocType; let last = last">
              <strong>{{ le.displayText }}</strong><span *ngIf="!last">, </span>
            </span>
          </small>
        </div>
      </div>
    </div>
    <div class="row m-0">
      <div class="px-3">
        <label for="active">
          <input id="active" type="checkbox" formControlName="isActive" />
          Active
        </label>
      </div>
    </div>
    <div class="row my-3 text-center">
      <div class="p-3 col">
        <button (click)="saveActivity()" eosDebounce [disabled]="!createForm.valid || missingLEsForDocType.length > 0"
          class="btn btn-secondary mx-2" type="submit">
          {{ isEdit ? 'Update' : 'Create' }}
        </button>
        <button class="btn btn-outline-primary me-2" (click)="onCancel()">Close</button>
      </div>
    </div>
  </form>
</div>